import Header from "../../components/layout/Header";
import HomePageContent from "../../components/layout/HomePageContent";
import "../../css/index.css";

const Home: React.FC = () => {
  return (
    <div className="wrapper">
      <Header />
      <HomePageContent />
    </div>
  );
};

export default Home;
